export class PermissionsConstants {
  public static VIEW_ORDER_HISTORY = 'VIEW_ORDER_HISTORY';
  public static PLACE_ORDERS = 'PLACE_ORDERS';
  public static CANCEL_ORDERS = 'CANCEL_ORDERS';
  public static EDIT_ORDERS = 'EDIT_ORDERS';
  public static VIEW_CREDIT_INFO = 'VIEW_CREDIT_INFO';
  public static VIEW_AND_PAY_INVOICES = 'VIEW_AND_PAY_INVOICES';
  public static VIEW_WHOLESALE_PRICE = 'VIEW_WHOLESALE_PRICE'; // Wholesale Price is the term for Dealer Price for SNAH
  public static CREATE_EDIT_DELETE_USERS = 'CREATE_EDIT_DELETE_USERS';
  public static SNAPPAY_INVOICE_STYLECLASSES = 'snappayInvoicesLink';
  public static ORDER_HISTORY_PAGE_ID = '/orders';
  public static ORDER_DETAILS_PAGE_ID = '/order';
  public static CHECKOUT_PAGE_ID = '/checkout';
  public static EDIT_EMPLOYEE_PAGE_ID = '/my-account/edit-employee';
}
